import type { FC, PropsWithChildren } from 'react';

export interface IBottomNavProps {
    className?: string;
}

export const BottomNav: FC<PropsWithChildren<IBottomNavProps>> = ({ className, children }) => {
    return <div className={`w-full bg-secondary-200 ${className}`}>{children}</div>;
};
